import React, {useEffect, useRef} from 'react'
import {defineMessage, useIntl} from 'react-intl'
import PropTypes from 'prop-types'
import {
    Box,
    Grid,
    GridItem,
    SimpleGrid,
    Stack
} from '@salesforce/retail-react-app/app/components/shared/ui'
import Field from '../../field'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import {MESSAGE_PROPTYPE} from '@salesforce/retail-react-app/app/utils/locale'
import useAddressFields from '../useAddressFields'
import {formStyles} from './index.styles'

const defaultFormTitleAriaLabel = defineMessage({
    defaultMessage: 'Address Form',
    id: 'use_address_fields.label.address_form'
})

const AddressFields = ({
    form,
    prefix = '',
    formTitleAriaLabel = defaultFormTitleAriaLabel,
    isBillingAddress = false,
    isAccountAddress = false
}) => {
    const {data: customer} = useCurrentCustomer()
    const fields = useAddressFields({form, prefix}, isAccountAddress)
    const intl = useIntl()
    const addressFormRef = useRef()
    useEffect(() => {
        addressFormRef?.current?.focus()
    }, [])

    return (
        <Stack
            spacing={5}
            aria-label={intl.formatMessage(formTitleAriaLabel)}
            tabIndex="0"
            ref={addressFormRef}
            sx={formStyles}
        >
            {!isBillingAddress && customer.isRegistered && <Field {...fields.c_addressName} />}
            <SimpleGrid columns={[1, 1, 2]} gap={5} spacing={0} marginTop={'0 !important'}>
                <Field {...fields.firstName} />
                <Field {...fields.lastName} />
            </SimpleGrid>
            <Field {...fields.phone} type="tel" autoComplete="off" />
            <Field {...fields.countryCode} />
            <Field {...fields.address1} />
            <Field {...fields.city} />
            <Grid templateColumns="repeat(8, 1fr)" gap={5} marginTop={'0px !important'}>
                <GridItem colSpan={[4, 4, 4]}>
                    <Field {...fields.stateCode} />
                </GridItem>
                <GridItem colSpan={[4, 4, 4]}>
                    <Field {...fields.postalCode} />
                </GridItem>
            </Grid>
            <Box marginTop={'0px !important'}>
                {customer.isRegistered && !isBillingAddress && <Field {...fields.preferred} />}
            </Box>
        </Stack>
    )
}

AddressFields.propTypes = {
    form: PropTypes.object.isRequired,
    prefix: PropTypes.string,
    formTitleAriaLabel: MESSAGE_PROPTYPE,
    isBillingAddress: PropTypes.bool,
    isAccountAddress: PropTypes.bool
}

export default AddressFields
